import { cn } from "@/lib/utils";
import { type Tone, type Labelled, toneSurface, toneDot } from "./labels";

// A calm plain-English pill. Callers translate an internal status with a `labels.ts`
// helper (which returns { label, tone }) and pass the result here. Never an enum string.
export function AttentionBadge({
  label,
  tone = "neutral",
  className,
  withDot = true,
}: {
  label: string;
  tone?: Tone;
  className?: string;
  withDot?: boolean;
}) {
  if (!label) return null;
  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 rounded-md border px-2 py-0.5 font-body text-[11px] font-medium leading-none",
        toneSurface(tone),
        className,
      )}
    >
      {withDot && <span className={cn("h-1.5 w-1.5 rounded-full shrink-0", toneDot(tone))} aria-hidden />}
      {label}
    </span>
  );
}

// Convenience overload for callers that already hold a Labelled.
export function AttentionBadgeFor({ value, className }: { value: Labelled; className?: string }) {
  return <AttentionBadge label={value.label} tone={value.tone} className={className} />;
}
